function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .clsReprogramadoPlanif-1 {\r\n        fill: #ffb717;\r\n      }\r\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "clsReprogramadoPlanif-1",
  d: "M9.2,14.8c-.4-1.3-.4-2.5,0-3.8.8-2.5,2.6-3.9,5.2-4.3H0v.3C0,10,0,13,0,16c0,1.2.7,1.9,1.9,1.9,3.1,0,6.2,0,9.3,0h.3c-1.1-.8-1.9-1.8-2.3-3.1Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "clsReprogramadoPlanif-1",
  d: "M15,7.9c-2.8,0-5,2.2-5,5,0,2.8,2.2,5,5,5,2.7,0,5-2.2,5-5,0-2.7-2.2-5-5-5ZM18.3,12.6l-1.8,1.6c-.1,0-.3.1-.4,0s-.2-.2-.2-.3v-.7h-1.1c-.6,0-1.1.5-1.1,1.1s.1.5.2.6c0,0,.1.1.1.2,0,.1,0,.2-.2.2s0,0,0,0c-.2-.1-1.1-.7-1.1-2s.9-2,1.9-2h1.2v-.7c0-.1,0-.3.2-.3.1,0,.3,0,.4,0l1.8,1.6c0,0,.1.2.1.3s0,.2-.1.3Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "clsReprogramadoPlanif-1",
  d: "M15.6,4.2c0-1.2-.7-1.8-1.9-1.9-.5,0-1,0-1.5,0,0-.5,0-.9,0-1.3,0-.4-.3-.7-.7-.8-.8-.2-1.4.3-1.4,1.1,0,.4,0,.7,0,1.1h-4.5c0-.2,0-.4,0-.6,0-.2,0-.5,0-.7,0-.4-.3-.7-.7-.8-.8-.2-1.4.3-1.4,1.1,0,.4,0,.7,0,1.1-.6,0-1.1,0-1.6,0C.7,2.3,0,3,0,4c0,.3,0,.7,0,1v.5h15.6c0-.5,0-1,0-1.5Z"
}))));

var SvgReprogramado = function SvgReprogramado(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 17.9",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReprogramado, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Reprogramado.c44f98e2.svg";
export { ForwardRef as ReactComponent };